/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { RectangleSkeleton } from '@fe-common-ui/Skeleton';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';

const DynamicDatePicker = dynamic(() => import('./DatePicker'), {
  loading: () => <RectangleSkeleton width={200} height={30} />,
  ssr: false
});

const DynamicLoadDatePicker = (props: any) => {
  return (
    <Suspense>
      <DynamicDatePicker {...props} />
    </Suspense>
  );
};

export default DynamicLoadDatePicker;
